import React, { useState, useEffect } from "react";
import { Link as RouterLink, useHistory } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import { makeStyles } from "@material-ui/styles";
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import { delete_agent } from "../../../../api/API";
import TableEditBar from "../../../../components/TableEditBar/TableEditBar";
import VisibilityIcon from "@material-ui/icons/Visibility";

import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/Email";
import DeleteIcon from "@material-ui/icons/Delete";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import EditAgent from "../../../EditAgent/EditAgent";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles((theme) => ({
  root: {},

  content: {
    padding: 0,
  },

  inner: {
    minWidth: 700,
  },

  nameCell: {
    display: "flex",
    alignItems: "center",
  },

  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },

  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end",
  },
}));

export default function TableList(props) {
  const { className, ...rest } = props;
  const [agents, setAgents] = useState(props.agents);
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    setAgents(props.agents);
  });

  //

  const [selectedAgency, setSelectedAgency] = useState(null);
  const handleEditClose = () => {
    setShowEdit(false);
    props.refresh();
  };
  const handleDelete = async (agency_id) => {
    if (window.confirm("Are you sure ?")) {
      let data = await delete_agent(agency_id);
      if (data) {
        props.refresh();
      } else {
        alert("Something went wrong");
      }
    }
  };
  const [showEdit, setShowEdit] = useState(false);

  const toPage = (agency_id) => {
    history.push("/agency/detailagency/" + agency_id);
  };

  return (
    <>
      <div {...rest} className={clsx(classes.root, className)}>
        <Typography color="textSecondary" gutterBottom variant="body2">
          {/* {agencies.length} Records found. Page {page + 1} of{' '}
            {Math.ceil(agencies.length / rowsPerPage)} */}
        </Typography>
        <Card>
          <CardHeader
            //   action={<GenericMoreButton />}
            title="Admin Details"
          />
          <Divider />
          <CardContent className={classes.content}>
              <div className={classes.inner + "  data_list_container"}>
                {agents.map((agent) => (
                  <div className="data_list_view">
                    <div className="info">
                      <h3>
                        <span
                          style={{
                            width: 14,
                            height: 14,
                            borderRadius: 7,
                            marginRight: 10,
                            display: "inline-block",
                            // backgroundColor: agency.color,
                          }}
                        ></span>
                        {agent.name}
                      </h3>
                      <p>
                        <EmailIcon></EmailIcon>
                        {agent.email}
                      </p>
                      {/* <p>
                        <ContactPhoneIcon></ContactPhoneIcon>
                        {agent.contact}
                      </p> */}
                    </div>
                    <div className="actions">
                      <div className="button_wrapper">
                        <Button
                          onClick={() => {
                            setSelectedAgency(agent);
                            setShowEdit(true);
                          }}
                          className="list_button"
                          variant="outlined"
                        >
                          <EditIcon></EditIcon>
                        </Button>
                        <Button
                          onClick={() => {
                            handleDelete(agent.agent_id);
                          }}
                          className="list_button"
                          variant="outlined"
                        >
                          <DeleteIcon></DeleteIcon>
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
          </CardContent>
        </Card>
        {showEdit && (
          <EditAgent
            agency={selectedAgency}
            onClose={handleEditClose}
            open={showEdit}
          />
        )}
      </div>
    </>
  );
}
